import { render, staticRenderFns } from "./ShPage.vue?vue&type=template&id=1efab8e0&scoped=true&"
import script from "./ShPage.vue?vue&type=script&lang=js&"
export * from "./ShPage.vue?vue&type=script&lang=js&"
import style0 from "./ShPage.vue?vue&type=style&index=0&id=1efab8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efab8e0",
  null
  
)

export default component.exports